import { useLocation } from 'react-router-dom';

interface InlineCtaBlockProps {
  targetSection?: string;
}

export default function InlineCtaBlock({ targetSection = '#contact' }: InlineCtaBlockProps) {
  const location = useLocation();

  const handleClick = () => {
    const isHomePage = location.pathname === '/';
    const targetPath = targetSection.startsWith('#') ? targetSection : `#${targetSection}`;
    
    if (!isHomePage && targetPath.startsWith('#')) {
      window.location.href = `/${targetPath}`;
    } else {
      const element = document.querySelector(targetPath);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="py-16 bg-gradient-to-br from-emerald-50 via-white to-slate-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div 
            className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-emerald-500 to-teal-500 shadow-lg"
          >
            <i className="ri-calendar-check-line text-3xl text-white"></i>
          </div>
        </div>

        {/* Heading */}
        <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          Book Your Free Consultation Today
        </h3>

        {/* Subtext */}
        <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto">
          Get practical advice from experienced hosts. No pressure, just clear guidance for your Tokyo minpaku journey.
        </p>

        {/* CTA Button */}
        <button
          onClick={handleClick}
          className="group inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-lg font-bold rounded-lg shadow-xl hover:shadow-2xl hover:shadow-emerald-500/30 hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <span>Schedule Free Consultation</span>
          <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
        </button>

        {/* Trust Indicators */}
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <div className="flex items-center gap-2 text-sm text-slate-600">
            <i className="ri-time-line text-emerald-600"></i>
            <span>30 minutes</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-slate-600">
            <i className="ri-shield-check-line text-emerald-600"></i>
            <span>No obligation</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-slate-600">
            <i className="ri-user-star-line text-emerald-600"></i>
            <span>Real host experience</span>
          </div>
        </div>
      </div>
    </div>
  );
}